// eslint-disable-next-line
import React, { FC, useState } from 'react';

import { FormikContextType, connect } from 'formik';

import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { KeyboardDatePicker as KeyboardDPicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { Nullable } from 'components/utils';
import { TextFieldProps } from 'formik-material-ui';
import { isValid } from 'date-fns';
import { customFieldToTextField, mapToSelectStyleProps } from './helpers';

export type KeyboardDatePickerProps = {
  inline?: boolean;
  formatValueToString?: boolean;
} & TextFieldProps;

// Release 20 : cuando se borra el input, el helperText sigue visible. not a Bug
const KeyboardDatePicker: FC<
  KeyboardDatePickerProps & {
    formik: FormikContextType<any>;
    invalidateMessage?: string;
  }
> = ({
  field,
  form,
  formik,
  inline,
  label,
  formatValueToString,
  invalidateMessage,
  ...restProps
}) => {
  const [datePickerError, setDatePickerError] = useState<string>('');
  const [tempValue, setTempValue] = useState<Date | string>(
    field.value ? field.value : null
  );

  const onError = (error) => {
    setDatePickerError(error);
  };

  const onChange = (date: MaterialUiPickersDate, value: Nullable<string>) => {
    if (formatValueToString) {
      const validValue: Date | string = date && isValid(date) ? date : '';
      setTempValue(validValue);
      form.setFieldValue(field.name, validValue);
      if (validValue) {
        form.setFieldTouched(field.name, true, false);
      }
      return;
    }
    const safeValue = isValid(date) ? date : '';
    if (safeValue) {
      setTempValue(safeValue);
      setDatePickerError('');
      form.setFieldValue(field.name, safeValue);
    } else {
      form.setFieldValue(field.name, null);
    }
  };

  const onBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    return false;
  };

  return (
    <KeyboardDPicker
      margin="dense"
      leftArrowIcon={<ArrowBack />}
      rightArrowIcon={<ArrowForward />}
      clearLabel="LIMPIAR"
      okLabel="ACEPTAR"
      cancelLabel="CANCELAR"
      format="dd/MM/yyyy"
      placeholder="DD/MM/AAAA"
      minDateMessage="La fecha ingresada es inválida"
      maxDateMessage="La fecha debe ser menor a la actual"
      invalidDateMessage={
        invalidateMessage ?? 'Fecha inválida, por favor intente nuevamente'
      }
      minDate={new Date(1900, 0, 1)}
      {...(customFieldToTextField({
        temporalError: datePickerError,
        form,
        field,
        ...restProps,
      }) as any)}
      // @ts-ignore
      value={tempValue}
      onError={onError}
      onBlur={onBlur}
      onChange={onChange}
      onDrop={onDrop}
      {...mapToSelectStyleProps({ formik, inline, field, label })}
    />
  );
};

export default connect<KeyboardDatePickerProps, any>(KeyboardDatePicker);
